import React, { useState, useEffect, useRef } from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import {
  Alert,
  Button,
  Card,
  Col,
  Collapse,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
  UncontrolledDropdown,
} from "reactstrap";
import { TRIVIA_USER_IDENTIFICATION_OPTIONS } from '../data'
import "./TriviaResultsResponses.css";
import { isMobile } from "../../../utils/deviceInfo";
import { validateEmail } from "../../../utils/validations";
import {
  LayoutHeading,
  LayoutRow,
  LayoutData,
} from "../../../components/TableComponents/RowBordered/RowBordered";
import If from "../../../components/Shared/If";
import ReactTooltip from "react-tooltip";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { toastContainer } from "../../../utils/toast";
import moment from "moment";
import EmptyTable from "../../../components/EmptyTable/EmptyTable";
import parse from "react-html-parser";
import {
  ActionLayoutData,
  ActionLayoutDataPlainBordered,
  ActionLayoutHeading,
  ActionLayoutHeadingPlainBordered,
} from "../../weekly-wins/TableLayoutComponents";
import {
  contvertHTMLToPlain,
  profilePicValidityCheck,
} from "../../../utils/constants";
import {
  BiCalendarAlt,
  BiCheck,
  BiDownArrowAlt,
  BiFilter,
  BiHash,
  BiHide,
  BiNotepad,
  BiSolidCalculator,
  BiSolidTimer,
  BiSolidWatchAlt,
  BiTimer,
  BiUpArrowAlt,
} from "react-icons/bi";
import MultirangeDatePickerDesigned from "./MultirangeDatePickerDesigned";
import { connect } from "react-redux";
import Loading from "../../../hoc/Loading/Loading";
import * as actionCreators from "../../../modules/actions/index";
import {
  BsDownload,
  BsFillEmojiExpressionlessFill,
  BsFillGearFill,
  BsThreeDotsVertical,
} from "react-icons/bs";
import Toggle from "react-toggle";
import Select from "react-select";
import { orderBy } from "lodash";
import {
  ATTEMPT_NO_FILTER,
  formatDuration,
  getAttemptNumberFilterOptions,
  getInputTypeLabel,
  isTrivvyGeneratedFromCustomTemplates,
  minPlanLimitCheck,
  SENTIMENTS_COLOR_MAP,
  SENTIMENTS_TYPO_MAP,
  showAsAnonymous,
  showYou,
} from "../data";
import { GiBigGear } from "react-icons/gi";
import MyTriviaDetails from "./MyTriviaDetails";
import { data } from "jquery";
import OoPopover from "../../../components/UI/Popover/OoPopover";
import { TagsInput } from "react-tag-input-component";
import SeeMoreWrapper from "../../../components/Shared/SeeMoreWrapper";
import { withRouter } from "react-router";
import SpinnerLoader from "../../../components/UI/SpinnerLoader/SpinnerLoader";

function TriviaResultsResponses({
  questions,
  surveyData,
  sortParams,
  updateSortParams,
  resultTableColsMap,
  setResultTableColsMap,
  allowAttempts,
  numberOfAttempts,
  user,
  hideActions,
  showTableForSummaryResponses,
  userSubmissions,
  notFetch,
  isFiltered,
  totalSumOfNumResponses = 0,
  setNeedsAttentionSortTrigger,
  needsAttentionSortTrigger,
  isFilterLoading,
  ...props
}) {
  const [responsesData, setResponsesData] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [table_columns, setTable_Columns] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [dropdownOpenCol, setDropdownOpenCol] = useState(null);
  const [questionsColDataObject, setQuestionsColDataObject] = useState(null);
  const [tableSettingsPopup, setTableSettingsPopup] = useState(false);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const hasSortedNeedsAttention = useRef(false);

  // Refs + vertical scroll sync for the "By User" table body. The headings
  // are kept outside the scroll (always visible); each column (User on the
  // left, question/response columns on the right) wraps its data rows in its
  // own vertically-scrollable div so the headers stay pinned. Because the
  // two data scrollers are siblings (one per column), we mirror scrollTop
  // between them on every scroll event so rows in the User column stay
  // aligned with rows in the right-side columns.
  const userDataScrollRef = useRef(null);
  const rightDataScrollRef = useRef(null);
  const isSyncingVScroll = useRef(false);

  const syncVScrollFromUser = (e) => {
    if (isSyncingVScroll.current) {
      isSyncingVScroll.current = false;
      return;
    }
    if (rightDataScrollRef.current) {
      isSyncingVScroll.current = true;
      rightDataScrollRef.current.scrollTop = e.target.scrollTop;
    }
  };

  const syncVScrollFromRight = (e) => {
    if (isSyncingVScroll.current) {
      isSyncingVScroll.current = false;
      return;
    }
    if (userDataScrollRef.current) {
      isSyncingVScroll.current = true;
      userDataScrollRef.current.scrollTop = e.target.scrollTop;
    }
  };

  const showRating =
    surveyData && surveyData.ratingPage && surveyData.ratingPage.display;

  const trivvyPlanType =
    user &&
    user.profile.organizationId &&
    user.profile.organizationId.trivvyPlanType;

  const showSentiment =
    surveyData &&
    surveyData.averageSentimentsScore &&
    surveyData.averageSentimentsScore.sentiment != null;

  const hasTextQuestion = questions && questions.some(q => q.question_type === "TEXT");

  const answerValueToPlainText = (answer) => {
    if (!answer) return "";

    const rawText = answer.text !== undefined && answer.text !== null ? answer.text : answer;

    if (typeof rawText === "string") {
      return contvertHTMLToPlain(rawText);
    }

    return JSON.stringify(rawText);
  };

  const selectedAnswersToPlainText = (selectedAnswers) => {
    if (!Array.isArray(selectedAnswers) || selectedAnswers.length === 0) {
      return "";
    }

    return selectedAnswers
      .flatMap((answer) => (Array.isArray(answer) ? answer : [answer]))
      .filter(Boolean)
      .map(answerValueToPlainText)
      .filter(Boolean)
      .join(", ");
  };

  const getResponseAnswerText = (response) => {
    if (!response || !Array.isArray(response.selected_answers)) {
      return "";
    }

    return selectedAnswersToPlainText(response.selected_answers);
  };


  const [filtersObject, setFiltersObject] = useState({
    dates: [],
    questionData: {
      selectedQuestion: null,
      selectedOption: [],
    },
    attemptNumber: 0,
    dropOffsFilter: {
      emails: [],
      users: [],
      isDropOffs: false,
    },
  });
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [rawResults, setRawResults] = useState([]);
  const [singleResultModalData, setSingleResultModalData] = useState(null);

  const isTextQTrivvy =
    questions &&
    questions.filter(
      (x) =>
        x.question_type == "TEXT"
    ).length > 0;

  const isKC = surveyData && surveyData.triviaCategoryType === "KNOWLEDGE_CHECK"
  const hasRetakes = allowAttempts > 0;
  const showRetakesColumn = isKC && hasRetakes;

  const handleDateChange = (value) => {
    const items = value.map((x) => new Date(x));
    setDateRange(items);
    if (items.length == 2 || items.length == 0) {
      setFiltersObject({
        ...filtersObject,
        dates: items,
      });

      getSurveyResponses({
        ...filtersObject,
        dates: items,
      });
    }
  };

  useEffect(() => {
    let arr = [];
    let allCols = [];
    if (resultTableColsMap.date) {
      arr.push({
        id: "date",
        text: "Response Date",
      });
    }

    if (resultTableColsMap.score && !isNonMcQTrivvy) {
      arr.push({
        id: "score",
        text: "Score",
      });
    }

    if (resultTableColsMap.duration || resultTableColsMap.duration !== false) {
      arr.push({
        id: "duration",
        text: "Total<br />Duration",
      });
    }

    for (const item in questionsColDataObject) {
      if (resultTableColsMap.hasOwnProperty(item)) {
        if (resultTableColsMap[item] === true) {
          arr.push(questionsColDataObject[item]);
        }
      } else {
        arr.push(questionsColDataObject[item]);
      }
    }

    // if (showRating && resultTableColsMap.rating) {
    //   arr.push({
    //     id: "rating",
    //     text: "Rating",
    //   });
    // }

    if (
      showSentiment &&
      (resultTableColsMap.sentiments || resultTableColsMap.sentiments !== false)
    ) {
      arr.push({
        id: "sentiments",
        text: "Sentiment",
      });
    }

    // Add Retakes column at the end when showRetakesColumn is true
    if (showRetakesColumn && (resultTableColsMap.retakes || resultTableColsMap.retakes !== false)) {
      arr.push({
        id: "retakes",
        text: "Retakes",
      });
    }

    // Add Needs Attention column at the end, like retakes
    if (resultTableColsMap.needsAttention !== false && surveyData && surveyData.triviaCategoryType !== "KNOWLEDGE_CHECK" && hasTextQuestion) {
      arr.push({
        id: "needsAttention",
        text: "Needs Attention",
      });
    }

    setTable_Columns(arr);
  }, [resultTableColsMap]);


    // Parse URL query params for initial sorting on mount
  useEffect(() => {
    const searchParams = new URLSearchParams(props.location.search);
    const sortBy = searchParams.get('sortBy');
    const sortOrder = searchParams.get('sortOrder');
    if ((!hasSortedNeedsAttention.current || needsAttentionSortTrigger) && sortBy === 'needsAttention' && sortOrder && responsesData && responsesData.length > 0) {
      updateSortParams({ sortBy, sortOrder });
      let list = [...responsesData];
      list = orderBy(list, (itm) => itm.needsAttention ? 1 : 0, [sortOrder]);
      setResponsesData(list);
      hasSortedNeedsAttention.current = true;
      setNeedsAttentionSortTrigger(false);
    }
  }, [responsesData, props.location.search, needsAttentionSortTrigger]);

  const handleSortChange = (key, order) => {
    let list = [...responsesData];
    switch (key) {
      case "date":
        list = orderBy(list, (itm) => itm.date ? moment(itm.date).valueOf() : 0, [order]);
        break;
      case "sentDate":
        list = orderBy(list, (itm) => itm.dateTrivvySent ? moment(itm.dateTrivvySent).valueOf() : 0, [order]);
        break;
      case "duration":
        list = orderBy(list, (itm) => itm.duration, [order]);
        break;
      case "score":
        list = orderBy(list, (itm) => itm.score, [order]);
        break;
      case "rating":
        list = orderBy(list, (itm) => itm.rating, [order]);
        break;
      case "retakes":
        list = orderBy(list, (itm) => itm.retakes, [order]);
        break;
      case "needsAttention":
        list = orderBy(list, (itm) => itm.needsAttention ? 1 : 0, [order]);
        break;
      case "user":
        list = orderBy(list, (itm) => getDisplayedUserName(itm.user, itm.isAnonymous).toLowerCase(), [order]);
        break;
      case "sentiments":
        list = orderBy(list, (itm) => {
          if (!itm.sentimentData || !itm.sentimentData.sentiment) return "";
          return SENTIMENTS_TYPO_MAP[itm.sentimentData.sentiment] || "";
        }, [order]);
        break;
      default:
        // Handle question columns (question_id sorting)
        list = orderBy(list, (itm) => {
          const response = itm.responses_arr.find(r => r.question_id === key);
          if (!response || !response.selected_answers || !response.selected_answers.length) return "";
          return selectedAnswersToPlainText(response.selected_answers).toLowerCase();
        }, [order]);
        break;
    }
    setResponsesData(list);
  };

  useEffect(() => {
    handleSortChange(sortParams.sortBy, sortParams.sortOrder);
  }, [sortParams]);

  const constructUserObjForExternalUser = (obj) => {
    console.log('247 --- ', obj)
    if (obj.email) {
      return {
        firstName: obj.email,
        identification: `(email)`,
        email: obj.email,
        mobileNumber: obj.mobileNumber
      };
    } else if (obj.name) {
      const arr = obj.name.split(" ");
      return {
        identification: `(name)`,
        firstName: arr[0],
        lastName: arr[1] || "",
        email: obj.email,
        mobileNumber: obj.mobileNumber
      };
    } else if (obj.mobileNumber) {
      return {
        identification: `(phone)`,
        firstName: obj.mobileNumber,
        email: obj.email,
        mobileNumber: obj.mobileNumber
      };
    } else if (obj.firstName || obj.lastName) {
      return {
        identification: `(name)`,
        firstName: obj.firstName || "",
        lastName: obj.lastName || "",
        email: obj.email,
        mobileNumber: obj.mobileNumber
      };
    } else if (obj.employeeId) {
      return {
        identification: `(employeeId)`,
        firstName: obj.employeeId,
        lastName: obj.lastName || "",
        email: '',
        mobileNumber: '',
        employeeId: obj.employeeId
      };
    } else {
      return {
        identification: "anonymous",
        firstName: obj.firstName || "",
        lastName: obj.lastName || "",
        email: obj.email,
        mobileNumber: obj.mobileNumber,
        employeeId: obj.employeeId
      };
    }
  };

  useEffect(() => {

    if (userSubmissions && userSubmissions.length === 1 && userSubmissions[0] === 'filter') {
      getSurveyResponses(filtersObject);
    } else if (userSubmissions && userSubmissions.users && userSubmissions.users.length > 0) {

      const data = { data: userSubmissions.users }
      setRawResults(data.data);
      const questionsDataMap = {};
      const questionsColDataMap = {};
      const questions_headers = questions.map((x) => {
        questionsDataMap[x.question_id] = {
          question_id: x.question_id,
          question_text: x.question_text,
        };
        questionsColDataMap[x.question_id] = {
          id: x.question_id,
          text: `${x.question_text} ${getInputTypeLabel(x.question_type)
              ? `(${getInputTypeLabel(x.question_type)})`
              : ""
            }`,
          theme_settings: x.theme_settings,
          display: true,
        };
      });

      setQuestionsColDataObject(questionsColDataMap);
      setResultTableColsMap({ ...resultTableColsMap, render: true });

      // For MESSAGING records, drop placeholder rows that have no SMS reply
      // text — they appear as duplicate "No response" entries next to the
      // real response from the same user.
      const filteredData = data.data.filter((result) => {
        if (!result.isMessaging) return true;
        return result.messagingResponse && result.messagingResponse.text;
      });
      const responses_array = filteredData.map((result) => {
        const resultDataMap = {};
        for (const i of result.responses) {
          resultDataMap[i.question_id] = {
            answer: i.selected_answers || [],
            time: i.timeTaken || 0,
            textSentimentsData: i.textSentimentsData || undefined,
          };
        }
        let duration = 0;
        for (const q of questions) {
          const sum = resultDataMap[q.question_id]
            ? resultDataMap[q.question_id].time || 0
            : 0;
          duration += sum;
        }

        const durationTotal = Math.round(result.totalOverallTime);
        return {
          _id: result._id,
          date: result.isSubmittedDate,
          dateTrivvySent: result.createdOn || result.dateTrivvySent,
          userId: result.userId ? result.userId._id : null,
          sentimentData:
            result.sentimentsScore && result.sentimentsScore.sentiment
              ? result.sentimentsScore
              : null,
          user: result.userId
            ? result.userId
            : result.userData
              ? constructUserObjForExternalUser(result.userData)
              : null,
          responses_arr: questions.map((res) => ({
            question_id: res.question_id,
            question_text: `${res.question_text} ${getInputTypeLabel(res.question_type)
                ? `(${getInputTypeLabel(res.question_type)})`
                : ""
              }`,
            textSentimentsData: resultDataMap[res.question_id]
              ? resultDataMap[res.question_id].textSentimentsData || undefined
              : [],
            question_type: res.question_type,
            correct_answer_id:
              (res.correct_options &&
                res.correct_options[0] &&
                res.correct_options[0].option_id) ||
              null,
            selected_answers: resultDataMap[res.question_id]
              ? resultDataMap[res.question_id].answer || []
              : [],

            timeTaken: resultDataMap[res.question_id]
              ? resultDataMap[res.question_id].time || 0
              : 0,
          })),
          score:
            result.totalQuestions > 0
              ? Math.round((result.totalCorrect / result.totalQuestions) * 100)
              : 0,
          rating: result.rating,
          ratingComment: result.ratingComment,
          duration: durationTotal,
          isAnonymous: result.isAnonymous,
          needsAttention: result.needsAttention,
        };
      });
      setResponsesData(responses_array);
    } else {
      setResponsesData([]);
      setRawResults([]);
      setQuestionsColDataObject(null);
      setResultTableColsMap({ ...resultTableColsMap, render: false });

    }

  }, [userSubmissions, notFetch])

  const getSurveyResponses = (filters) => {
    axios
      .post(url.getTriviaSubmissions(surveyData._id), {
        filter: filters,
      })
      .then(({ data }) => {
        let rawData = data.data;
        // Group by user and keep only latest submission when showRetakesColumn is true
        let processedData = rawData;
        let retakesCountMap = {};

        if (showRetakesColumn) {
          const userSubmissionsMap = {};
          // Group submissions by userId
          rawData.forEach((result) => {
            const userKey = (result.userId && result.userId._id) ||
              (result.userData && result.userData.email);

            if (!userSubmissionsMap[userKey]) {
              userSubmissionsMap[userKey] = [];
            }
            userSubmissionsMap[userKey].push(result);
          });

          // For each user, keep only the latest submission and count retakes
          processedData = [];
          Object.entries(userSubmissionsMap).forEach(([userKey, submissions]) => {
            // Sort by completed date (most recent first)
            const sortedSubmissions = submissions.sort((a, b) =>
              new Date(b.isSubmittedDate || b.createdOn) - new Date(a.isSubmittedDate || a.createdOn)
            );

            // Get the latest submission
            const latestSubmission = sortedSubmissions[0];

            // Store retakes count (0 if taken once, starts at 1 for second attempt)
            retakesCountMap[latestSubmission._id] = sortedSubmissions.length - 1;

            processedData.push(latestSubmission);
          });
        }

        setRawResults(processedData);
        console.log('406 data res --- ', processedData)
        const questionsDataMap = {};
        const questionsColDataMap = {};
        const questions_headers = questions.map((x) => {
          questionsDataMap[x.question_id] = {
            question_id: x.question_id,
            question_text: x.question_text,
          };
          questionsColDataMap[x.question_id] = {
            id: x.question_id,
            text: `${x.question_text} ${getInputTypeLabel(x.question_type)
              ? `(${getInputTypeLabel(x.question_type)})`
              : ""
              }`,
            theme_settings: x.theme_settings,
            display: true,
          };
        });

        setQuestionsColDataObject(questionsColDataMap);
        setResultTableColsMap({ ...resultTableColsMap, render: true });

        // For MESSAGING records, drop placeholder rows that have no SMS
        // reply text — they appear as duplicate "No response" entries
        // next to the real response from the same user.
        const filteredProcessedData = processedData.filter((result) => {
          if (!result.isMessaging) return true;
          return result.messagingResponse && result.messagingResponse.text;
        });
        const responses_array = filteredProcessedData.map((result) => {
          const resultDataMap = {};
          for (const i of result.responses) {
            resultDataMap[i.question_id] = {
              answer: i.selected_answers || [],
              time: i.timeTaken || 0,
              textSentimentsData: i.textSentimentsData || undefined,
            };
          }
          let duration = 0;
          for (const q of questions) {
            const sum = resultDataMap[q.question_id]
              ? resultDataMap[q.question_id].time || 0
              : 0;
            duration += sum;
          }

          const durationTotal = Math.round(result.totalOverallTime);
          return {
            _id: result._id,
            date: result.isSubmittedDate,
            dateTrivvySent: result.createdOn || result.dateTrivvySent,
            userId: result.userId ? result.userId._id : null,
            sentimentData:
              result.sentimentsScore && result.sentimentsScore.sentiment
                ? result.sentimentsScore
                : null,
            user: result.userId
              ? result.userId
              : result.userData
                ? constructUserObjForExternalUser(result.userData)
                : null,
            responses_arr: questions.map((res) => ({
              question_id: res.question_id,
              question_text: `${res.question_text} ${getInputTypeLabel(res.question_type)
                ? `(${getInputTypeLabel(res.question_type)})`
                : ""
                }`,
              textSentimentsData: resultDataMap[res.question_id]
                ? resultDataMap[res.question_id].textSentimentsData || undefined
                : [],
              question_type: res.question_type,
              correct_answer_id:
                (res.correct_options &&
                  res.correct_options[0] &&
                  res.correct_options[0].option_id) ||
                null,
              selected_answers: resultDataMap[res.question_id]
                ? resultDataMap[res.question_id].answer || []
                : [],

              timeTaken: resultDataMap[res.question_id]
                ? resultDataMap[res.question_id].time || 0
                : 0,
            })),
            score:
              result.totalQuestions > 0
                ? Math.round(
                  (result.totalCorrect / result.totalQuestions) * 100
                )
                : 0,
            rating: result.rating,
            ratingComment: result.ratingComment,
            duration: durationTotal,
            isAnonymous: result.isAnonymous,
            retakes: retakesCountMap[result._id] || 0,
            // Add needsAttention to each response object in responses_arr, mirroring retakes at the result level
            needsAttention: result.needsAttention,
          };
        });
        console.log('482responses_array --- ', responses_array.length)

        setResponsesData(responses_array);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {

    if (!(userSubmissions && userSubmissions.users && userSubmissions.users.length > 0) && !(userSubmissions && userSubmissions.length === 1 && userSubmissions[0] === 'filter') && (!isFiltered)) {


      getSurveyResponses(filtersObject);
    }

  }, [userSubmissions]);

  const applyQuestionFilters = () => {
    getSurveyResponses(filtersObject);
  };

  const handleColWidth = (key, mobile) => {
    if (key === "user") {
      if (mobile) {
        return 1;
      } else {
        return 2;
      }
    }
    if (key === "sentDate") {
      if (mobile) {
        return 1;
      } else {
        return 1;
      }
    }
    if (key === "score") {
      if (mobile) {
        return 1;
      } else {
        return 1;
      }
    }
    if (key === "duration") {
      if (mobile) {
        return 1;
      } else {
        return 1;
      }
    }
    if (showSentiment && key === "sentiments") {
      if (mobile) {
        return 1;
      } else {
        return 1;
      }
    }
    if (showRetakesColumn && key === "retakes") {
      if (mobile) {
        return 1;
      } else {
        return 1;
      }
    }
    if (showRating && key === "rating") {
      if (mobile) {
        return 1;
      } else {
        return 1;
      }
    }
    if (key === "date") {
      if (mobile) {
        return 1;
      } else {
        return 1;
      }
    }
    if (key === "questions") {
      if (mobile) {
        return 2;
      } else {
        return 2;
      }
    }
    if (key === "needsAttention") {
      if (mobile) {
        return 1;
      } else {
        return 1;
      }
    }
  };

  const sortComponent = (key) => {
    if (
      JSON.stringify(sortParams.sortBy) === JSON.stringify(key) &&
      sortParams.sortOrder === "asc"
    ) {
      return <BiDownArrowAlt size={"18px"} on />;
    } else {
      return <BiUpArrowAlt size={"18px"} />;
    }
  };

  const changeSortField = (key, sortOrder) => {
    updateSortParams({
      sortBy: key,
      sortOrder: sortOrder,
    });
  };

  const hideColumn = (col) => {
    setResultTableColsMap({
      ...resultTableColsMap,
      [col]: false,
    });
  };
  const showColumn = (col) => {
    setResultTableColsMap({
      ...resultTableColsMap,
      [col]: true,
    });
  };

  const toggleCol = (col) => {
    setDropdownOpenCol(dropdownOpenCol ? null : col);
  };

  const isNonMcQTrivvy =
    questions &&
    questions.filter(
      (x) =>
        x.correct_options && x.correct_options[0] && x.correct_options[0].text
    ).length == 0;

  // MESSAGING discriminator used by the Insights "Submissions" modal
  // (showTableForSummaryResponses branch). Aligned with the same
  // currentTrivvy.isMessaging flag read in TriviaResultsInsights.jsx.
  const isMessagingSubmission = !!(surveyData && surveyData.isMessaging);

  const renderDDtab = (col) => {
    let sortOrder = "";
    if (
      JSON.stringify(sortParams.sortBy) === JSON.stringify(col) &&
      sortParams.sortOrder === "asc"
    ) {
      sortOrder = "desc";
    } else {
      sortOrder = "asc";
    }

    if (col != "name") {
      return (
        <Dropdown isOpen={dropdownOpenCol == col} toggle={() => toggleCol(col)}>
          <DropdownToggle
            size="lg"
            tag={"span"}
            className="action-table-col-overlap"
          >
            <span className="TriviaEditViewListUI_leftContainer_singleQuestion_threedots_wrapper">
              <BsThreeDotsVertical />
            </span>
          </DropdownToggle>
          <DropdownMenu>
            {/* Sort is now available for ALL columns */}
            <DropdownItem onClick={() => changeSortField(col, sortOrder)}>
              {sortComponent(col)} Sort
            </DropdownItem>

            {col !== "user" && (
              <DropdownItem onClick={() => hideColumn(col)}>
                <BiHide size={"22px"} /> Hide column{" "}
              </DropdownItem>
            )}
          </DropdownMenu>
        </Dropdown>
      );
    } else {
      return (
        <span
          className="action-title-mob"
          onClick={() => changeSortField("actionTitle", sortOrder)}
        >
          {col} {sortComponent(col)}
        </span>
      );
    }
  };

  let totalColsCounter = 0;

  if (resultTableColsMap.sentDate !== false) {
    totalColsCounter += handleColWidth("sentDate", isMobile);
  }

  for (const i of table_columns) {
    if (i.id == "date") {
      totalColsCounter += handleColWidth("date", isMobile);
    } else if (i.id == "score") {
      totalColsCounter += handleColWidth("score", isMobile);
    } else if (showRating && i.id == "rating") {
      totalColsCounter += handleColWidth("rating", isMobile);
    } else if (i.id == "duration") {
      totalColsCounter += handleColWidth("duration", isMobile);
    } else if (showSentiment && i.id == "sentiments") {
      totalColsCounter += handleColWidth("sentiments", isMobile);
    } else if (showRetakesColumn && i.id == "retakes") {
      totalColsCounter += handleColWidth("retakes", isMobile);
    } else if (i.id == "needsAttention") {
      totalColsCounter += handleColWidth("needsAttention", isMobile);
    } else {
      totalColsCounter += handleColWidth("questions", isMobile);
    }
  }

  if (isFilterLoading) {
    return (
      <div style={{ marginTop: "48px", minHeight: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <SpinnerLoader />
      </div>
    );
  }

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";

    if (firstName == "N" && lastName == "N") {
      if (user.email) {
        return user.email.charAt(0) + user.email.split('@')[1].charAt(0)
      } else {
        return;
      }

    } else {
      return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
    }

  };

  const question_options = questions.map((x) => ({
    value: x.question_id,
    label: contvertHTMLToPlain(x.question_text),
  }));

  const generateLinearNumericOptions = (linearNumericConfigs) => {
    if (!linearNumericConfigs) return [];

    let min = linearNumericConfigs.min || 0;
    const max = linearNumericConfigs.max || 10;
    const minLabel = linearNumericConfigs.minLabel || '';
    const maxLabel = linearNumericConfigs.maxLabel || '';

    // If min is 0, use 1 instead
    if (min === 0) {
      min = 1;
    }

    const options = [];
    for (let i = min; i <= max; i++) {
      let label = String(i);

      // Add labels for min and max values
      if (i === min && minLabel) {
        label = `${i} - ${minLabel}`;
      } else if (i === max && maxLabel) {
        label = `${i} - ${maxLabel}`;
      }

      options.push({
        label: label,
        value: String(i),
      });
    }
    return options;
  };

  const option_options = (() => {
    if (!filtersObject.questionData || !filtersObject.questionData.selectedQuestion) {
      return [];
    }

    const selectedQuestion = filtersObject.questionData.selectedQuestion;

    // For LINEAR_NUMERIC questions, generate options from linearNumericConfigs
    if (selectedQuestion.question_type === "LINEAR_NUMERIC" || selectedQuestion.question_type === "LINEAR_SCALE") {
      return generateLinearNumericOptions(selectedQuestion.linearNumericConfigs);
    }

    // For MCQ questions, use the options array (keep as is - working fine)
    if (selectedQuestion.options && Array.isArray(selectedQuestion.options)) {
      return selectedQuestion.options.map((x) => ({
        label: contvertHTMLToPlain(x.text),
        value: x.option_id,
      }));
    }

    return [];
  })();

  const limitChars = (text) => {
    if (text.length > 35) {
      return text.substring(0, 35) + "...";
    } else {
      return text;
    }
  };

  let isDataExists = responsesData && responsesData.length > 0;

  const applyFiltersDisabled = () => {
    if (filtersObject.questionData) {
      if (
        (filtersObject.questionData.selectedQuestion &&
          filtersObject.questionData.selectedOption &&
          filtersObject.questionData.selectedOption.length) ||
        filtersObject.attemptNumber >= 0
      ) {
        return false;
      } else {
        return true;
      }
    }
  };

  // Trigger the Results-by-User CSV export. The BE owns the entire CSV
  // file (data fetching, business rules, RFC 4180 escape, date formatting,
  // Content-Disposition headers) — the FE only forwards the admin's local
  // timezone offset (so dates render in the user's zone) and the desired
  // filename, then triggers the browser download from the response blob.
  const handleExportCSV = () => {
    if (exportLoading) return;
    setExportLoading(true);

    const questionCount = surveyData.questions ? surveyData.questions.length : "";
    const filename = `${surveyData.name} (${questionCount} Questions) - ${moment().format("MM/DD/YYYY")}`;
    const tzOffsetMinutes = moment().utcOffset();

    axios
      .get(url.getResultsByUserCSV(surveyData._id), {
        responseType: "blob",
        params: { tz: tzOffsetMinutes, filename: filename },
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", filename + ".csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(downloadUrl);
      })
      .catch((err) => {
        console.error("Error exporting Results by User CSV:", err);
        toastContainer("Failed to export CSV. Please try again.", "error");
      })
      .finally(() => {
        setExportLoading(false);
      });
  };

  const hideIdentityForThisView =
    surveyData &&
    surveyData.allowAnonymousResponses &&
    Array.isArray(responsesData) &&
    responsesData.length > 0 &&
    responsesData.length <= 5;



  // function getIdentityDisplay(user) {
  //   var pref = "";
  //   if (surveyData && surveyData.userIdentificationOptions) {
  //     pref = Array.isArray(surveyData.userIdentificationOptions)
  //       ? surveyData.userIdentificationOptions[0]
  //       : surveyData.userIdentificationOptions;
  //   }

  //     // find the matching option
  // var field = "", val = ''

  // for (var i = 0; i < TRIVIA_USER_IDENTIFICATION_OPTIONS.length; i++) {
  //   var opt = TRIVIA_USER_IDENTIFICATION_OPTIONS[i];
  //   if (opt.value === pref) {
  //     field = opt.field || "email";
  //     val = field ? user[field] : "";
  //     if(opt.value =="FIRST_LAST_NAME" ){
  //       val = `${user.firstName} ${user.lastName}`
  //     }
  //     break;
  //   }
  // }
  // // var v = field ? user[field] : "";
  // return val != null ? String(val).trim() : "";
  // }

  function getIdentityDisplay(user, isAnonymousFlag) {
    // If we should hide identity (global rule) OR this specific result is anonymous
    if (!user || hideIdentityForThisView || isAnonymousFlag) {
      return "Anonymous user";
    }

    var pref = "";
    if (surveyData && surveyData.userIdentificationOptions) {
      pref = Array.isArray(surveyData.userIdentificationOptions)
        ? surveyData.userIdentificationOptions[0]
        : surveyData.userIdentificationOptions;
    }

    // find the matching option
    var field = "", val = "";
    for (var i = 0; i < TRIVIA_USER_IDENTIFICATION_OPTIONS.length; i++) {
      var opt = TRIVIA_USER_IDENTIFICATION_OPTIONS[i];
      if (opt.value === pref) {
        field = opt.field || "email";
        val = field ? user[field] : "";
        if (opt.value === "FIRST_LAST_NAME") {
          val = (user.firstName ? user.firstName : "") + " " + (user.lastName ? user.lastName : "");
        }
        break;
      }
    }
    val = val != null ? String(val).trim() : "";

    // If chosen field is empty, still fall back to anonymized label
    if (!val) {
      return "Anonymous user";
    }
    return val;
  }

  const getDisplayedUserName = (user, isAnonymous) => {
    if (!user || isAnonymous) return "Anonymous user";
    const name = ((user.firstName ? user.firstName : "") + " " + (user.lastName ? user.lastName : "")).trim();
    if (name) return name;
    return getIdentityDisplay(user, isAnonymous);
  };

  const hasIdentityValue = (obj) => {
    if (!obj || typeof obj !== "object") return false;

    var keys = ["email", "employeeId", "mobileNumber", "firstName", "lastName"];
    for (var i = 0; i < keys.length; i++) {
      var v = obj[keys[i]];
      if (v !== null && v !== undefined && String(v).trim() !== "") {
        return true;
      }
    }
    return false;
  }

  const getPercentScore = (result) => {
    return Math.round((result.score / questions.length) * 100);
  };

  const openSingleResultModal = (resId, resUser, triviaCategoryType) => {
    const resObj = rawResults.find((x) => x._id == resId);
    if (resObj) {
      const modalData = {
        resultId: resObj._id,
        isAnonymous: resObj.isAnonymous,
        quizResponses: resObj.responses,
        triviaId: resObj.triviaId,
        percentCorrect: resObj.percentCorrect,
        sourceLink: surveyData.uploadUrl,
        triviaName: surveyData.name,
        quizSubmittedAt: resObj.createdOn,
        totalTime: resObj.totalTime,
        completion: resObj.completion,
        rating: resObj.rating,
        ratingComment: resObj.ratingComment,
        userResultObj: resUser,
        triviaCategoryType: triviaCategoryType,
      };

      setSingleResultModalData(modalData);
    }
  };
  console.log('869 responsesData -- ', responsesData)

  return (
    <div className="trivia-results-container-component">
      {singleResultModalData && singleResultModalData.resultId ? (
        <MyTriviaDetails
          open={true}
          onClose={() => {
            setSingleResultModalData(null);
          }}
          data={singleResultModalData}
          hideReminder
        />
      ) : (
        ""
      )}

      {!hideActions && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {isMobile ? (
            <div className="d-flex align-items-center">
              <MultirangeDatePickerDesigned
                dateRange={dateRange}
                handleDateChange={handleDateChange}
                noAlert
              />

              <div
                className="action-table-filter-btn px-3 ml-2 py-1 cursor-pointer"
                style={{
                  height: "34px",
                  borderRadius: "5px",
                  fontSize: "14px",
                }}
                onClick={() => setFiltersOpen(true)}
              >
                <span>Question Filters</span>
                <BiFilter className="cursor-pointer" id="Modal1" />
              </div>

              <UncontrolledDropdown className="ml-2">
                <DropdownToggle
                  style={{ maxHeight: "34px" }}
                  size="sm"
                  className="trivia-action-button-main"
                >
                  <BsFillGearFill size={14} />
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem onClick={handleExportCSV} disabled={exportLoading} className="text-dark">
                    {exportLoading ? "Exporting..." : "Export CSV"} <BsDownload size={13} />
                  </DropdownItem>
                  {/* <DropdownItem  onClick={() => setFiltersOpen(true)}>
                  Question Filters  <BiFilter className="cursor-pointer" id="Modal1" />
                </DropdownItem> */}
                  {!isNonMcQTrivvy &&
                    !isTrivvyGeneratedFromCustomTemplates(surveyData) && (
                      <DropdownItem
                        onClick={() => setCollapseOpen(!collapseOpen)}
                      >
                        {collapseOpen ? "Hide" : "Show"} Answers <BiNotepad />
                      </DropdownItem>
                    )}

                  <DropdownItem onClick={() => setTableSettingsPopup(true)}>
                    Table Settings{" "}
                    <BsFillGearFill size={15} data-tip={"Table settings"} />
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <MultirangeDatePickerDesigned
                dateRange={dateRange}
                handleDateChange={handleDateChange}
                noAlert
              />
              <div className="ml-3">
                <button
                  onClick={handleExportCSV}
                  disabled={exportLoading}
                  className="btn btn-sm trivia-action-button-main h-fitcontent"
                >
                  {exportLoading ? "Exporting..." : "Export CSV"} <BsDownload size={13} />
                </button>
              </div>
              <div className="ml-3">
                <div
                  className="action-table-filter-btn px-3 py-1 cursor-pointer"
                  style={{
                    height: "34px",
                    borderRadius: "5px",
                    fontSize: "14px",
                  }}
                  onClick={() => setFiltersOpen(true)}
                >
                  <span>Question Filters</span>
                  <BiFilter className="cursor-pointer" id="Modal1" />
                </div>
              </div>

              {!isNonMcQTrivvy &&
                !isTrivvyGeneratedFromCustomTemplates(surveyData) && (
                  <div className="ml-3">
                    <Button
                      color="primary"
                      size="sm"
                      style={{
                        height: "33px",
                      }}
                      onClick={() => setCollapseOpen(!collapseOpen)}
                    >
                      {collapseOpen ? "Hide" : "Show"} Answers
                    </Button>
                  </div>
                )}

              {responsesData && responsesData.length ? (
                <div
                  className="cursor-pointer"
                  style={{
                    padding: "4px",
                    marginLeft: "10px",
                  }}
                >
                  <BsFillGearFill
                    size={19}
                    data-tip={"Table settings"}
                    onClick={() => setTableSettingsPopup(true)}
                  />
                </div>
              ) : (
                ""
              )}

              {minPlanLimitCheck(trivvyPlanType, "002") && (
                <div>
                  <OoPopover
                    target="trivvy_colors_info"
                    headerText="Table legend"
                    placement="bottom"
                    bodyText={
                      <div>
                        <div className="">MCQ questions</div>
                        <div className="my-2 d-flex align-items-center">
                          <span
                            style={{
                              backgroundColor: "rgb(215 250 239 / 40%)",
                            }}
                            className="color-chip-trivvy-response-table"
                          ></span>
                          indicates correct answer
                        </div>
                        <div className="my-2 d-flex align-items-center">
                          <span
                            style={{
                              backgroundColor: "rgb(255 213 205 / 40%)",
                            }}
                            className="color-chip-trivvy-response-table"
                          ></span>
                          indicates wrong answer
                        </div>
                        <div className="mt-3">Text input - Sentiments</div>
                        <div className="my-2 d-flex align-items-center">
                          <span
                            style={{
                              backgroundColor: SENTIMENTS_COLOR_MAP["POSITIVE"],
                            }}
                            className="color-chip-trivvy-response-table"
                          ></span>
                          indicates positive sentiment
                        </div>

                        <div className="my-2 d-flex align-items-center">
                          <span
                            style={{
                              backgroundColor: SENTIMENTS_COLOR_MAP["NEGATIVE"],
                            }}
                            className="color-chip-trivvy-response-table"
                          ></span>
                          indicates negative sentiment
                        </div>
                        <div className="my-2 d-flex align-items-center ">
                          <span
                            style={{
                              backgroundColor: SENTIMENTS_COLOR_MAP["NEUTRAL"],
                            }}
                            className="color-chip-trivvy-response-table"
                          ></span>
                          indicates neutral sentiment
                        </div>
                        <div className="my-2 d-flex align-items-center">
                          <span
                            style={{
                              backgroundColor: SENTIMENTS_COLOR_MAP["MIXED"],
                            }}
                            className="color-chip-trivvy-response-table"
                          ></span>
                          indicates mixed sentiment
                        </div>
                      </div>
                    }
                  />
                </div>
              )}
            </div>
          )}

          <Modal
            isOpen={tableSettingsPopup}
            className="trivia_result_setting_modal"
          >
            <ModalHeader
              className="trivia_modal_header_bg"
              toggle={() => setTableSettingsPopup(!tableSettingsPopup)}
            >
              Table Settings (Hide or show columns)
            </ModalHeader>

            <ModalBody>
              <div className="my-4 d-flex align-items-center justify-content-between">
                <span>Response Date</span>
                <span>
                  <Toggle
                    icons={false}
                    checked={resultTableColsMap["date"]}
                    onChange={() =>
                      resultTableColsMap["date"]
                        ? hideColumn("date")
                        : showColumn("date")
                    }
                  />
                </span>
              </div>
              <div className="my-4 d-flex align-items-center justify-content-between">
                <span>Total Duration</span>
                <span>
                  <Toggle
                    icons={false}
                    checked={resultTableColsMap["duration"]}
                    onChange={() =>
                      resultTableColsMap["duration"]
                        ? hideColumn("duration")
                        : showColumn("duration")
                    }
                  />
                </span>
              </div>
              <div className="my-4 d-flex align-items-center justify-content-between">
                <span>Sent Date</span>
                <span>
                  <Toggle
                    icons={false}
                    checked={resultTableColsMap["sentDate"]}
                    onChange={() =>
                      resultTableColsMap["sentDate"]
                        ? hideColumn("sentDate")
                        : showColumn("sentDate")
                    }
                  />
                </span>
              </div>

              {showSentiment && (
                <div className="my-4 d-flex align-items-center justify-content-between">
                  <span>Sentiments</span>
                  <span>
                    <Toggle
                      icons={false}
                      checked={resultTableColsMap["sentiments"]}
                      onChange={() =>
                        resultTableColsMap["sentiments"]
                          ? hideColumn("sentiments")
                          : showColumn("sentiments")
                      }
                    />
                  </span>
                </div>
              )}

              {questions.map((que) => {
                let showCol = false;
                if (resultTableColsMap.hasOwnProperty(que.question_id)) {
                  if (resultTableColsMap[que.question_id] === true) {
                    showCol = true;
                  }
                } else {
                  showCol = true;
                }
                return (
                  <div className="my-4 d-flex align-items-center justify-content-between">
                    <span>{parse(que.question_text)}</span>
                    <span>
                      <Toggle
                        icons={false}
                        checked={showCol}
                        onChange={() =>
                          showCol
                            ? hideColumn(que.question_id)
                            : showColumn(que.question_id)
                        }
                      />
                    </span>
                  </div>
                );
              })}

              {!isNonMcQTrivvy && (
                <div className="my-4 d-flex align-items-center justify-content-between">
                  <span>Score</span>
                  <span>
                    <Toggle
                      icons={false}
                      checked={resultTableColsMap["score"]}
                      onChange={() =>
                        resultTableColsMap["score"]
                          ? hideColumn("score")
                          : showColumn("score")
                      }
                    />
                  </span>
                </div>
              )}
              {/* {showRating && (
                <div className="my-4 d-flex align-items-center justify-content-between">
                  <span>Rating</span>
                  <span>
                    <Toggle
                      icons={false}
                      checked={resultTableColsMap["rating"]}
                      onChange={() =>
                        resultTableColsMap["rating"]
                          ? hideColumn("rating")
                          : showColumn("rating")
                      }
                    />
                  </span>
                </div>
              )} */}
            </ModalBody>
          </Modal>

          <Modal isOpen={filtersOpen}>
            <ModalHeader
              className="trivia_modal_header_bg"
              toggle={() => setFiltersOpen(false)}
            >
              Question Filters
            </ModalHeader>
            <ModalBody className="p-4">
              {allowAttempts > 0 && numberOfAttempts > 0 && (
                <div className="mt-2 mb-3">
                  <Label>Select attempt number </Label>
                  <Select
                    options={getAttemptNumberFilterOptions(numberOfAttempts)}
                    className="select-trivvy-attempt-filter-200"
                    placeholder={"Select attempt number"}
                    value={filtersObject.attemptNumber}
                    onChange={(e) => {
                      setFiltersObject({
                        ...filtersObject,
                        attemptNumber: e.value,
                      });
                    }}
                    style={{
                      width: "200px",
                    }}
                  />
                </div>
              )}

              <Label>Please select question.</Label>
              <Select
                options={question_options}
                value={
                  filtersObject.questionData &&
                  filtersObject.questionData.selectedQuestion &&
                  filtersObject.questionData.selectedQuestion.question_id
                }
                onChange={(t) => {
                  setFiltersObject({
                    ...filtersObject,
                    questionData: {
                      ...filtersObject.questionData,
                      selectedQuestion: questions.find(
                        (x) => x.question_id == t.value
                      ),
                      selectedOption: null,
                    },
                  });
                }}
                placeholder="Select Question"
              />

              <div className="mt-4 d-flex ">
                <span style={{
                  color: filtersObject.questionData &&
                    filtersObject.questionData.selectedQuestion &&
                    filtersObject.questionData.selectedQuestion.question_type === "TEXT"
                    ? "#999"
                    : "inherit"
                }}>
                  Includes Selected Option
                </span>

                <div style={{ flex: 1 }} className="ml-4">
                  <Select
                    className="ml-2"
                    options={option_options}
                    value={
                      (filtersObject.questionData &&
                        filtersObject.questionData.selectedOption &&
                        filtersObject.questionData.selectedOption) ||
                      []
                    }
                    onChange={(t) => {
                      setFiltersObject({
                        ...filtersObject,
                        questionData: {
                          ...filtersObject.questionData,
                          selectedOption: t.map((x) => x.value),
                        },
                      });
                    }}
                    multi
                    placeholder="Select Options"
                    disabled={
                      !filtersObject.questionData ||
                      !filtersObject.questionData.selectedQuestion ||
                      filtersObject.questionData.selectedQuestion.question_type === "TEXT"
                    }
                  />
                </div>
              </div>


              {/* <div className="my-3">
                <b>Filter dropoffs by Email</b>
                <Toggle
                  className="ml-2"
                  checked={filtersObject.dropOffsFilter.isDropOffs}
                  onChange={(e) => {
                    setFiltersObject({
                      ...filtersObject,
                      dropOffsFilter: {
                        ...filtersObject.dropOffsFilter,
                        isDropOffs: e.target.checked,
                      },
                    });
                  }}
                />
              </div>  */}


            </ModalBody>
            <ModalFooter>
              <Button
                onClick={() => {
                  setFiltersObject({
                    ...filtersObject,
                    questionData: {
                      selectedOption: [],
                      selectedQuestion: null,
                    },
                    attemptNumber: 0,
                    dropOffsFilter: {
                      emails: [],
                      users: [],
                      isDropOffs: false,
                    },
                  });
                  getSurveyResponses({
                    ...filtersObject,
                    questionData: {
                      selectedOption: [],
                      selectedQuestion: null,
                    },
                    attemptNumber: 0,
                    dropOffsFilter: {
                      emails: [],
                      users: [],
                      isDropOffs: false,
                    },
                  });
                }}
              >
                Clear
              </Button>
              <Button
                className="ml-3"
                color="primary"
                onClick={() => {
                  applyQuestionFilters();
                  setFiltersOpen(false);
                }}
                disabled={applyFiltersDisabled()}
              >
                Apply
              </Button>
            </ModalFooter>
          </Modal>

          <ReactTooltip />
        </div>
      )}

      <Collapse isOpen={collapseOpen} className="">
        <div className="collapse-trivia-qa">
          <div className="table-responsive">
            <Table>
              <thead>
                <tr>
                  <th>Question</th>

                  <th>Answer</th>
                </tr>
              </thead>
              <tbody>
                {questions.map((question) => {
                  if (question.question_type == "MCQ") {
                    return (
                      <tr>
                        <td>{parse(question.question_text)}</td>
                        <td>
                          <span className="text-success">
                            {question.question_type == "MCQ"
                              ? question.correct_options &&
                              question.correct_options[0] &&
                              question.correct_options[0].text
                              : "NA"}
                          </span>
                        </td>
                      </tr>
                    );
                  } else {
                    return null;
                  }
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </Collapse>

      <hr />


      {showTableForSummaryResponses ? (
        <div>
          {responsesData.length > 0 ? (
            <div className="table-responsive">
              <Table className={"plain-summary-results-table"}>
                <thead>
                  <tr>
                    {/* <th>User</th> */}
                    <th className="text-center">Response Date</th>
                    <th className="text-center">Sentiment</th>
                    {/* SURVEY-only columns. MESSAGING hides Score (no MCQ
                        scoring) and Retakes (not a KC concept). */}
                    {!isMessagingSubmission && !isNonMcQTrivvy && <th className="text-center">Score</th>}
                    {!isMessagingSubmission && showRetakesColumn && <th className="text-center">Retakes</th>}
                    {/* Needs Attention column is always present per the
                        Insights submissions spec. */}
                    <th className="text-center">Needs Attention</th>
                  </tr>
                </thead>
                <tbody>
                  {responsesData.map((result, i) => {
                    const sentimentKey =
                      result.sentimentData && result.sentimentData.sentiment
                        ? result.sentimentData.sentiment
                        : null;
                    return (
                      <tr>
                        {/* <td className="plain-summary-results-table-user">
                          {result.user && !result.isAnonymous ? (
                            <span
                              className="trivia_table_text_wrapper"
                              onClick={(e) => {
                                e.stopPropagation();

                                if (result.user._id) {
                                  props.history.push(
                                    `/home/${user.profile.organizationId._id}/profile/${result.user._id}`
                                  );
                                }
                              }}
                            >
                              {profilePicValidityCheck(
                                result.user.profilePic
                              ) ? (
                                <img
                                  src={result.user.profilePic}
                                  height="35px"
                                  width="35px"
                                  style={{ borderRadius: "50%" }}
                                />
                              ) : (
                                <span
                                  className="spotlightUserInitials"
                                  data-letters={getInitials(result.user)}
                                ></span>
                              )}{" "}
                              {getIdentityDisplay(result.user, result.isAnonymous)}
                            </span>
                          ) : (
                            <span className="trivia_table_text_wrapper">
                              <span
                                className="spotlightUserInitials"
                                data-letters={"AU"}
                              ></span>
                              Anonymous user{" "}
                              {showYou(user.profile, result) ? "(You)" : ""}
                            </span>
                          )}
                        </td> */}
                        <td className="text-center">
                          <span className="trivia_table_text_wrapper">
                            {result.date ? (
                              <>
                                {moment(result.date).format("ll")}
                                <br />
                                {moment(result.date).format("LT")}
                              </>
                            ) : (
                              "—"
                            )}
                          </span>
                        </td>
                        <td className="text-center">
                          <span className="trivia_table_text_wrapper">
                            {sentimentKey
                              ? SENTIMENTS_TYPO_MAP[sentimentKey] || "—"
                              : "—"}
                          </span>
                        </td>
                        {!isMessagingSubmission && !isNonMcQTrivvy && (
                          <td className="text-center">{result.score}%</td>
                        )}
                        {!isMessagingSubmission && showRetakesColumn && (
                          <td className="text-center">{result.retakes || 0}</td>
                        )}
                        <td className="text-center">
                          {result.needsAttention ? (
                            <FaExclamationTriangle color="goldenrod" size="1.8em" />
                          ) : (
                            "—"
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <EmptyTable title={"No results found"} />
            </div>
          )}
        </div>
      ) : (
        <div>
          {surveyData.allowAnonymousResponses && responsesData.length <= 5 && responsesData.length > 0 ? (
            <div className={`actions-table-div cursor-default  p0`}>
              <LayoutRow
                className="mobileNoheightActionTable"
                style={{
                  minHeight: "400px",
                  backgroundColor:
                    responsesData && responsesData.length > 0
                      ? ""
                      : "rgb(145 144 144 / 8%)",
                  border: "1px rgb(128 128 128 / 46%) solid",
                }}
              >
                <Col
                  xs={isMobile ? 5 : table_columns.length === 3 ? 5 : 2}
                  // xs={isMobile ? 5 : 2}
                  className="px-0"
                >
                  <div>
                    <ActionLayoutHeadingPlainBordered
                      className="p-3 border-gray-thin"
                      colWidth={handleColWidth("user", false)}
                      fullWidth
                    >
                      <span style={{ flex: 1 }}>User</span>
                      {renderDDtab("user")}
                    </ActionLayoutHeadingPlainBordered>
                  </div>

                  <div
                    style={{
                      position: "absolute",
                      left: "100%",
                      width: "100%",
                      zIndex: "10",
                      background: "white",
                      top: "40%",
                      boxShadow: "0 1px 4px rgba(0,0,0,.24)",
                      marginLeft: "80%",
                      textAlign: "center",
                      padding: "10px",
                      borderRadius: "0.5rem",
                    }}
                  >
                    Too few responses to maintain anonymity
                  </div>
                </Col>
                <Col
                  xs={isMobile ? 7 : table_columns.length === 3 ? 7 : 9}
                  className="scrollable-action-table-row px-0"
                >
                  <Row
                    className="row-scroll-width"
                    style={{
                      //width: `${totalColsCounter * 122}px`,
                      width: `100%`,
                      flexWrap: "nowrap",
                    }}
                  >
                    {resultTableColsMap.sentDate !== false && (
                      <ActionLayoutHeadingPlainBordered
                        className="p-3 border-gray-thin"
                        colWidth={handleColWidth("sentDate", false)}
                        plainTable
                      >
                        <span style={{ flex: 1 }}>
                          Sent<br />Date
                        </span>
                        {renderDDtab("sentDate")}
                      </ActionLayoutHeadingPlainBordered>
                    )}
                    {table_columns.map((e, idx) => {
                      const odd_or_eve = e.order % 2 == 0 ? "even" : "odd";
                      return (
                        <ActionLayoutHeadingPlainBordered
                          className="p-3 border-gray-thin"
                          colWidth={
                            e.id == "score" ||
                              e.id == "date" ||
                              e.id == "rating" ||
                              e.id == "duration" ||
                              e.id == "sentiments" ||
                              e.id == "retakes"
                              ? 1
                              : handleColWidth("questions", isMobile)
                          }
                          key={e.question_id}
                          plainTable
                        >
                          {e.theme_settings && (
                            <div
                              className={`TriviaEditViewListUI_leftContainer_singleQuestion_chip_color_${odd_or_eve} mr-1
                      `}
                              style={{
                                backgroundColor:
                                  e.theme_settings.quizBackgroundColor,
                                color: e.theme_settings.quizTextColor,
                                width: "max-content",
                              }}
                            >
                              <span className="TriviaEditViewListUI_leftContainer_singleQuestion_chip_sign_div">
                                {" "}
                                {odd_or_eve == "odd" ? (
                                  <>{questions.findIndex(q => q.question_id === e.id) + 1} </>
                                ) : (
                                  <>{questions.findIndex(q => q.question_id === e.id) + 1} </>
                                )}{" "}
                              </span>{" "}
                            </div>
                          )}{" "}
                          {e.id == "score" && (
                            <BiSolidCalculator
                              color="gray"
                              size={23}
                              className="mr-2"
                            />
                          )}
                          <span style={{ flex: 1 }} data-tip={parse(e.text)}>
                            {" "}
                            {parse(limitChars(e.text))}{" "}
                          </span>
                          {renderDDtab(e.id)}
                          <ReactTooltip />
                        </ActionLayoutHeadingPlainBordered>
                      );
                    })}
                  </Row>

                </Col>
              </LayoutRow>
            </div>
          ) : responsesData.length > 0 ? (
            <div className={`${surveyData && surveyData.triviaCategoryType === "SURVEY" ? 'actions-table-div cursor-pointer-imp' : 'actions-table-div cursor-default '}  results-invidual-table p0 trivvyUserResTable`}>
              <LayoutRow
                className="mobileNoheightActionTable"
                style={{
                  minHeight: "400px",
                  backgroundColor:
                    responsesData && responsesData.length > 0
                      ? ""
                      : "#8080802b",
                }}
              >
                <Col
                  xs={(() => {
                    const totalCols = table_columns.length + (resultTableColsMap.sentDate !== false ? 1 : 0);
                    return isMobile ? 3 : totalCols === 4 ? 3 : 3;
                  })()}
                  className="px-0"
                >
                  <div
                    ref={userDataScrollRef}
                    onScroll={syncVScrollFromUser}
                    className="trivvyUserResTable-data-scroll-left"
                  >
                  <div className="trivvyUserResTable-sticky-header">
                    <ActionLayoutHeadingPlainBordered
                      className={`p-3 border-gray-thin-right ${isDataExists ? "" : "border-gray-thin-bottom"
                        }`}
                      colWidth={handleColWidth("user", false)}
                      fullWidth
                    >
                      <span style={{ flex: 1 }}>User</span>
                      {renderDDtab("user")}
                    </ActionLayoutHeadingPlainBordered>
                  </div>

                  {/* responses by user  */}
                  {responsesData &&
                    responsesData.map((result, i) => {
                      return (
                        <ActionLayoutDataPlainBordered
                          className={"border-gray-thin cursor-pointer"}
                          key={`${result._id}-${i}`}
                          onClick={() => {
                            openSingleResultModal(result._id, result.user, surveyData.triviaCategoryType)
                          }}
                        >
                          {hasIdentityValue(result.user) && !result.isAnonymous ? (
                            <span
                              className="trivia_table_text_wrapper"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (result.user._id) {
                                  props.history.push(
                                    `/home/${user.profile.organizationId._id}/profile/${result.user._id}`
                                  );
                                }
                              }}
                            >
                              {profilePicValidityCheck(
                                result.user.profilePic
                              ) ? (
                                <img
                                  src={result.user.profilePic}
                                  height="35px"
                                  width="35px"
                                  style={{ borderRadius: "50%" }}
                                />
                              ) : (
                                <span
                                  className="spotlightUserInitials"
                                  data-letters={getInitials(result.user)}
                                ></span>
                              )}{" "}
                              {getDisplayedUserName(result.user, result.isAnonymous)}
                            </span>
                          ) : (
                            <span className="trivia_table_text_wrapper">
                              <span
                                className="spotlightUserInitials"
                                data-letters={"AU"}
                              ></span>
                              Anonymous user{" "}
                              {showYou(user.profile, result) ? "(You)" : ""}
                            </span>
                          )}
                          <span className="trivia-tbl-txt-view-btn">(view)</span>
                        </ActionLayoutDataPlainBordered>
                      );
                    })}
                  </div>
                </Col>
                <Col
                  xs={isMobile ? 9 : table_columns.length === 3 ? 7 : 9}
                  className="px-0"
                >
                  <div
                    ref={rightDataScrollRef}
                    onScroll={syncVScrollFromRight}
                    className="trivvyUserResTable-data-scroll-right"
                  >
                  <div
                    className="trivvyUserResTable-sticky-header"
                    style={{ width: `${totalColsCounter * 122}px` }}
                  >
                  <Row
                    className="row-scroll-width"
                    style={{
                      width: `${totalColsCounter * 122}px`,
                      flexWrap: "nowrap",
                      margin: 0,
                    }}
                  >
                    {resultTableColsMap.sentDate !== false && (
                      <ActionLayoutHeadingPlainBordered
                        className="p-3 border-gray-thin"
                        colWidth={handleColWidth("sentDate", false)}
                        plainTable
                      >
                        <span style={{ flex: 1 }}>
                          Sent<br />Date
                        </span>
                        {renderDDtab("sentDate")}
                      </ActionLayoutHeadingPlainBordered>
                    )}
                    {table_columns.map((e, idx) => {
                      const odd_or_eve = e.order % 2 == 0 ? "even" : "odd";
                      return (
                        <ActionLayoutHeadingPlainBordered
                          className={`${e.id === "retakes" || e.id === "duration" || e.id === "needsAttention" ? "text-center" : ""} p-3 border-gray-thin`}
                          colWidth={
                            e.id == "score" ||
                              e.id == "date" ||
                              e.id == "rating" ||
                              e.id == "duration" ||
                              e.id == "sentiments" ||
                              e.id == "retakes" || e.id == "needsAttention"
                              ? 1
                              : handleColWidth("questions", isMobile)
                          }
                          key={e.question_id}
                          plainTable
                        >
                          {e.theme_settings && (
                            <div
                              className={`TriviaEditViewListUI_leftContainer_singleQuestion_chip_color_${odd_or_eve} mr-1
                      `}
                              style={{
                                backgroundColor:
                                  e.theme_settings.quizBackgroundColor,
                                color: e.theme_settings.quizTextColor,
                                width: "max-content",
                              }}
                            >
                              <span className="TriviaEditViewListUI_leftContainer_singleQuestion_chip_sign_div">
                                {" "}
                                {odd_or_eve == "odd" ? (
                                  <> {questions.findIndex(q => q.question_id === e.id) + 1} </>
                                ) : (
                                  <> {questions.findIndex(q => q.question_id === e.id) + 1} </>
                                )}{" "}
                              </span>{" "}
                            </div>
                          )}{" "}
                          {e.id == "sentiments" && (
                            <BsFillEmojiExpressionlessFill
                              color="gray"
                              size={23}
                              className="mr-2"
                            />
                          )}
                          {e.id == "score" && (
                            <BiSolidCalculator
                              color="gray"
                              size={23}
                              className="mr-2"
                            />
                          )}
                          <span
                            style={{ flex: 1 }}
                            data-tip={contvertHTMLToPlain(e.text)}
                          >
                            {" "}
                            {parse(limitChars(e.text))}{" "}
                          </span>
                          {renderDDtab(e.id)}
                          <ReactTooltip />
                        </ActionLayoutHeadingPlainBordered>
                      );
                    })}
                  </Row>
                  </div>
                  {responsesData.map((result, i) => {
                    return (
                      <LayoutRow
                        className={`pl-tasks-row row-scroll-width ${surveyData.triviaCategoryType === "SURVEY" ? 'cursor-pointer' : ''} `}
                        style={{ width: `${totalColsCounter * 122}px` }}
                        onClick={() => {
                          if (surveyData && surveyData.triviaCategoryType === "SURVEY") {
                            openSingleResultModal(result._id, result.user, surveyData.triviaCategoryType)
                          }
                        }}
                      >
                        {resultTableColsMap.sentDate !== false && (
                          <ActionLayoutDataPlainBordered
                            colWidth={handleColWidth("sentDate", isMobile)}
                          >
                            <span className={"trivia_table_text_wrapper"}>
                              {result.dateTrivvySent ? (
                                <>
                                  {moment(result.dateTrivvySent).format("ll")}
                                  <br />
                                  {moment(result.dateTrivvySent).format("LT")}
                                </>
                              ) : (
                                "No Date"
                              )}
                            </span>
                          </ActionLayoutDataPlainBordered>
                        )}

                        {resultTableColsMap["date"] && (
                          <ActionLayoutDataPlainBordered
                            colWidth={handleColWidth("date", isMobile)}
                          >
                            <span className={"trivia_table_text_wrapper"}>
                              {moment(result.date).format("ll")}
                              <br />
                              {moment(result.date).format("LT")}
                              {/* {new Date(result.date).toLocaleString()} */}
                            </span>
                          </ActionLayoutDataPlainBordered>
                        )}

                        {!isNonMcQTrivvy && resultTableColsMap["score"] ? (
                          <ActionLayoutDataPlainBordered
                            colWidth={handleColWidth("score", isMobile)}
                            className="text-center"
                          >
                            {isTrivvyGeneratedFromCustomTemplates(surveyData) ||
                              isNonMcQTrivvy ? (
                              <span>N/A</span>
                            ) : (
                              <span>{result.score}%</span>
                            )}
                          </ActionLayoutDataPlainBordered>
                        ) : (
                          ""
                        )}

                        {resultTableColsMap["duration"] != false ? (
                          <ActionLayoutDataPlainBordered
                            colWidth={handleColWidth("duration", isMobile)}
                            className="text-center"
                            customStyle={{ fontSize: '12px', padding: '12px' }}
                            noPadding={true}
                          >
                            {formatDuration(result.duration)}.
                          </ActionLayoutDataPlainBordered>
                        ) : (
                          ""
                        )}

                        {result.responses_arr.map((res) => {
                          const q_id = res.question_id;
                          let showCol = false;
                          if (resultTableColsMap.hasOwnProperty(q_id)) {
                            if (resultTableColsMap[q_id] === true) {
                              showCol = true;
                            }
                          } else {
                            showCol = true;
                          }

                          if (showCol) {
                            const selectedAnswers = Array.isArray(res.selected_answers)
                              ? res.selected_answers.filter(Boolean)
                              : [];
                            const answer = selectedAnswers[0];
                            const answerText = getResponseAnswerText(res);
                            const hasAnswer = answerText.length > 0;

                            const isCorrect =
                              res.question_type == "MCQ" && answer
                                ? answer.option_id === res.correct_answer_id
                                : false;

                            const isWrong =
                              res.question_type == "MCQ" && answer && res.correct_answer_id
                                ? answer.option_id !== res.correct_answer_id
                                : false;


                            return (
                              <ActionLayoutDataPlainBordered
                                colWidth={handleColWidth("questions", isMobile)}
                                className={
                                  res.question_type == "MCQ" &&
                                  !isTrivvyGeneratedFromCustomTemplates(
                                    surveyData
                                  ) &&
                                  (isCorrect
                                    ? "trivia-result-tablecell-correct" : isWrong ?
                                      "trivia-result-tablecell-wrong" : "")
                                }
                                customStyle={{
                                  ...(res.question_type == "TEXT" &&
                                    res.textSentimentsData &&

                                    res.textSentimentsData.sentiment
                                    ? {
                                      backgroundColor:
                                        SENTIMENTS_COLOR_MAP[
                                        res.textSentimentsData.sentiment
                                        ],
                                    }
                                    : {}),
                                }}
                              >
                                {hasAnswer ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      paddingTop: '2px'
                                    }}
                                  >
                                    <span className={"trivia_table_text_wrapper"}>
                                      <SeeMoreWrapper
                                        text={answerText}
                                        limit={50}
                                        openModal={() => {
                                          openSingleResultModal(result._id, result.user)
                                        }}
                                      />
                                      {/* {parse(
                                    typeof answer.text == "string"
                                      ? answer.text
                                      : JSON.stringify(answer.text)
                                  )} */}
                                    </span>

                                    <div className="d-flex align-items-center">
                                      {res.question_type == "TEXT" &&
                                        res.textSentimentsData &&

                                        res.textSentimentsData.sentiment ? (
                                        <div
                                          style={{
                                            fontSize: "10px",
                                            fontWeight: 500,
                                          }}
                                          className="trivia-tbl-txt-sentiment-itm mr-2"
                                        >
                                          {" "}
                                          <b>
                                            (
                                            {
                                              SENTIMENTS_TYPO_MAP[
                                              res.textSentimentsData.sentiment
                                              ]
                                            }{" "}
                                            sentiment)
                                          </b>
                                        </div>
                                      ) : null}

                                      <div
                                        style={{
                                          fontSize: "10px",
                                          color: "blue",
                                          fontWeight: "500",
                                        }}
                                      >
                                        {res.timeTaken
                                          ? `Time Taken: ${formatDuration(
                                            Math.round(res.timeTaken)
                                          )}`
                                          : ""}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <span className={"trivia_table_text_wrapper"}>
                                    {" "}
                                    Not Answered.
                                    <div
                                      className={"trivia_table_text_wrapper"}
                                      style={{
                                        fontSize: "10px",
                                        color: "blue",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {res.timeTaken
                                        ? `Time Taken: ${res.timeTaken} seconds`
                                        : ""}
                                    </div>
                                  </span>
                                )}
                              </ActionLayoutDataPlainBordered>
                            );
                          } else {
                            return;
                          }
                        })}

                        {/* {showRating && resultTableColsMap["rating"] != false ? (
                          <ActionLayoutDataPlainBordered
                            colWidth={handleColWidth("rating", isMobile)}
                          >
                            <span className={"trivia_table_text_wrapper"}>
                              {result.rating || "No rating"}
                            </span>
                            <br/>
                            <span className={"trivia_table_text_wrapper"} style={{color:'blue',textDecoration:'umynderline',cursor:"pointer"}} 
                              data-tip={result.ratingComment || "No comment"}
                            >
                              {result.ratingComment ? "See Comment": "No Comment"}
                              
                            </span>
                            {result.ratingComment && (

                            <ReactTooltip />
                            )}

                            

                          </ActionLayoutDataPlainBordered>
                        ) : (
                          ""
                        )} */}

                        {showSentiment &&
                          resultTableColsMap["sentiments"] != false ? (
                          <ActionLayoutDataPlainBordered
                            colWidth={handleColWidth("sentiments", isMobile)}
                          >
                            <span className={"trivia_table_text_wrapper"}>
                              {result.sentimentData ? (
                                <div>
                                  {
                                    SENTIMENTS_TYPO_MAP[
                                    result.sentimentData.sentiment
                                    ]
                                  }
                                </div>
                              ) : (
                                "N/A"
                              )}
                            </span>
                          </ActionLayoutDataPlainBordered>
                        ) : (
                          ""
                        )}

                        {showRetakesColumn &&
                          resultTableColsMap["retakes"] != false ? (
                          <ActionLayoutDataPlainBordered
                            colWidth={handleColWidth("retakes", isMobile)}
                            className="text-center"
                          >
                            <span className={"trivia_table_text_wrapper"}>
                              {result.retakes || 0}
                            </span>
                          </ActionLayoutDataPlainBordered>
                        ) : (
                          ""
                        )}

                        {resultTableColsMap["needsAttention"] != false && surveyData && surveyData.triviaCategoryType !== "KNOWLEDGE_CHECK" && hasTextQuestion ? (
                          <ActionLayoutDataPlainBordered
                            colWidth={handleColWidth("needsAttention", isMobile)}
                            className="text-center"
                          >
                            <span className={"trivia_table_text_wrapper"}>
                              {result.needsAttention ? (
                                <FaExclamationTriangle color="goldenrod" size="1.8em" />
                              ) : (
                                "-"
                              )}
                            </span>
                          </ActionLayoutDataPlainBordered>
                        ) : (
                          ""
                        )}
                      </LayoutRow>
                    );
                  })}
                  </div>
                </Col>
              </LayoutRow>
            </div>
          ) : (
            <div className={`actions-table-div cursor-default  p0`}>
              <LayoutRow
                className="mobileNoheightActionTable"
                style={{
                  minHeight: "400px",
                  backgroundColor:
                    responsesData && responsesData.length > 0
                      ? ""
                      : "rgb(145 144 144 / 8%)",
                  border: "1px rgb(128 128 128 / 46%) solid",
                }}
              >
                <Col
                  xs={isMobile ? 3 : table_columns.length === 3 ? 5 : 3}
                  className="px-0"
                >
                  <div>
                    <ActionLayoutHeadingPlainBordered
                      className="p-3 border-gray-thin"
                      colWidth={handleColWidth("user", false)}
                      fullWidth
                    >
                      <span style={{ flex: 1 }}>User</span>
                      {renderDDtab("user")}
                    </ActionLayoutHeadingPlainBordered>
                  </div>

                  <div
                    style={{
                      position: "absolute",
                      left: "100%",
                      width: "100%",
                      zIndex: "10",
                      background: "white",
                      top: "40%",
                      boxShadow: "0 1px 4px rgba(0,0,0,.24)",
                      marginLeft: "80%",
                      textAlign: "center",
                      padding: "10px",
                      borderRadius: "0.5rem",
                    }}
                  >
                    No data has been recorded yet.
                  </div>
                </Col>
                <Col
                  xs={isMobile ? 9 : table_columns.length === 3 ? 7 : 9}
                  className="scrollable-action-table-row px-0"
                >
                  <Row
                    className="row-scroll-width"
                    style={{
                      //width: `${totalColsCounter * 122}px`,
                      width: `100%`,
                      flexWrap: "nowrap",
                    }}
                  >
                    {resultTableColsMap.sentDate !== false && (
                      <ActionLayoutHeadingPlainBordered
                        className="p-3 border-gray-thin"
                        colWidth={handleColWidth("sentDate", false)}
                        plainTable
                      >
                        <span style={{ flex: 1 }}>
                          Sent <br /> Date
                        </span>
                        {renderDDtab("sentDate")}
                      </ActionLayoutHeadingPlainBordered>
                    )}
                    {table_columns.map((e, idx) => {
                      const odd_or_eve = e.order % 2 == 0 ? "even" : "odd";
                      return (
                        <ActionLayoutHeadingPlainBordered
                          className="p-3 border-gray-thin"
                          colWidth={
                            e.id == "score" ||
                              e.id == "date" ||
                              e.id == "rating" ||
                              e.id == "duration" ||
                              e.id == "sentiments"
                              ? 1
                              : handleColWidth("questions", isMobile)
                          }
                          key={e.question_id}
                          plainTable
                        >
                          {e.theme_settings && (
                            <div
                              className={`TriviaEditViewListUI_leftContainer_singleQuestion_chip_color_${odd_or_eve} mr-1
                      `}
                              style={{
                                backgroundColor:
                                  e.theme_settings.quizBackgroundColor,
                                color: e.theme_settings.quizTextColor,
                                width: "max-content",
                              }}
                            >
                              <span className="TriviaEditViewListUI_leftContainer_singleQuestion_chip_sign_div">
                                {" "}
                                {odd_or_eve == "odd" ? (
                                  <> {questions.findIndex(q => q.question_id === e.id) + 1} </>
                                ) : (
                                  <> {questions.findIndex(q => q.question_id === e.id) + 1} </>
                                )}{" "}
                              </span>{" "}
                            </div>
                          )}{" "}
                          {e.id == "score" && (
                            <BiSolidCalculator
                              color="gray"
                              size={23}
                              className="mr-2"
                            />
                          )}
                          <span style={{ flex: 1 }} data-tip={parse(e.text)}>
                            {" "}
                            {parse(limitChars(e.text))}{" "}
                          </span>
                          {renderDDtab(e.id)}
                          <ReactTooltip />
                        </ActionLayoutHeadingPlainBordered>
                      );
                    })}
                  </Row>
                  {responsesData &&
                    responsesData.length > 0 &&
                    responsesData.map((result, i) => {
                      return (
                        <LayoutRow
                          className={`pl-tasks-row row-scroll-width`}
                          style={{ width: `${totalColsCounter * 122}px` }}
                        >
                          {resultTableColsMap["date"] ? (
                            <ActionLayoutDataPlainBordered
                              colWidth={handleColWidth("date", isMobile)}
                            >
                              <span className={"trivia_table_text_wrapper"}>
                                {moment(result.date).format("ll")}
                                <br />
                                {moment(result.date).format("LT")}
                                {/* {new Date(result.date).toLocaleString()} */}
                              </span>
                            </ActionLayoutDataPlainBordered>
                          ) : (
                            ""
                          )}

                          {showRating && resultTableColsMap["rating"] ? (
                            <ActionLayoutDataPlainBordered
                              colWidth={handleColWidth("rating", isMobile)}
                            >
                              <span className={"trivia_table_text_wrapper"}>
                                {result.rating || "No rating"}
                              </span>
                            </ActionLayoutDataPlainBordered>
                          ) : (
                            ""
                          )}

                          {!isNonMcQTrivvy && resultTableColsMap["score"] ? (
                            <ActionLayoutDataPlainBordered
                              colWidth={handleColWidth("score", isMobile)}
                              className="text-center"
                            >
                              {result.score}%
                            </ActionLayoutDataPlainBordered>
                          ) : (
                            ""
                          )}

                          {result.responses_arr.map((res) => {
                            const q_id = res.question_id;
                            let showCol = false;
                            if (resultTableColsMap.hasOwnProperty(q_id)) {
                              if (resultTableColsMap[q_id] === true) {
                                showCol = true;
                              }
                            } else {
                              showCol = true;
                            }

                            if (showCol) {
                              const selectedAnswers = Array.isArray(res.selected_answers)
                                ? res.selected_answers.filter(Boolean)
                                : [];
                              const answer = selectedAnswers[0];
                              const answerText = getResponseAnswerText(res);
                              const hasAnswer = answerText.length > 0;

                              const isCorrect =
                                res.question_type == "MCQ" && answer && res.correct_answer_id
                                  ? answer.option_id === res.correct_answer_id
                                  : false;
                              const isWrong =
                                res.question_type == "MCQ" && answer && res.correct_answer_id
                                  ? answer.option_id !== res.correct_answer_id
                                  : false;

                              return (
                                <ActionLayoutDataPlainBordered
                                  colWidth={handleColWidth("questions", isMobile)}
                                  className={
                                    res.question_type == "MCQ" &&
                                    (isCorrect
                                      ? "trivia-result-tablecell-correct" : isWrong ?
                                        "trivia-result-tablecell-wrong" : "")
                                  }
                                >
                                  {hasAnswer ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <span
                                        className={"trivia_table_text_wrapper"}
                                        data-tip={answerText}
                                      >
                                        {answerText}
                                      </span>
                                      <div
                                        className={"trivia_table_text_wrapper"}
                                        style={{
                                          fontSize: "10px",
                                          color: "blue",
                                          fontWeight: "500",
                                        }}
                                      >
                                        {res.timeTaken
                                          ? `Time Taken: ${res.timeTaken} seconds`
                                          : ""}
                                      </div>
                                    </div>
                                  ) : (
                                    <span className={"trivia_table_text_wrapper"}>
                                      {" "}
                                      Not Answered.
                                    </span>
                                  )}

                                  <ReactTooltip />
                                </ActionLayoutDataPlainBordered>
                              );
                            } else {
                              return;
                            }
                          })}
                        </LayoutRow>
                      );
                    })}
                </Col>
              </LayoutRow>
            </div>
            // <div className="text-center">
            //   <EmptyTable
            //     title="No data found"
            //     subtitle={"No data found for results."}
            //   />
            // </div>
          )}
        </div>
      )}

    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    sortParams:
      state.sortFilterParams && state.sortFilterParams.triviaResultList
        ? state.sortFilterParams.triviaResultList.sort &&
          state.sortFilterParams.triviaResultList.sort.hasOwnProperty("sortBy")
          ? state.sortFilterParams.triviaResultList.sort
          : { sortBy: "", sortOrder: "" }
        : { sortBy: "", sortOrder: "" },
    resultTableColsMap: state.trivia.resultTableColsMap || {
      date: true,
      score: true,
      duration: true,
      sentDate: true,
    },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateSortParams: (data) =>
      dispatch(actionCreators.updateTriviaResultSort(data)),
    setResultTableColsMap: (data) =>
      dispatch(actionCreators.setResultTableColsMap(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(TriviaResultsResponses, axios)));
